/** Shared EN / 中文 segmented toggle used by the Story and Characters panels. */
import { Languages } from 'lucide-react'

import type { DramaLang } from '@/types/drama'

export function LangToggle({
  lang,
  onChange,
  disabled,
  hint,
}: {
  lang: DramaLang
  onChange: (l: DramaLang) => void
  disabled?: boolean
  /** Dim + tooltip when the current content is likely single-language. */
  hint?: boolean
}) {
  const opts: { key: DramaLang; label: string }[] = [
    { key: 'en', label: 'EN' },
    { key: 'zh', label: '中文' },
  ]
  return (
    <div
      className={`inline-flex items-center rounded-md border overflow-hidden ${hint ? 'opacity-60' : ''}`}
      title={hint ? '当前内容可能仅有单语，重新生成可获得双语' : '切换语言'}
    >
      <Languages className="w-3.5 h-3.5 mx-1.5 text-muted-foreground" />
      {opts.map((o) => (
        <button
          key={o.key}
          type="button"
          disabled={disabled}
          onClick={() => onChange(o.key)}
          className={`px-2.5 py-1 text-xs transition-colors disabled:opacity-50 ${
            lang === o.key
              ? 'bg-spectrum-magenta text-white'
              : 'text-muted-foreground hover:bg-accent/50'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  )
}
